var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-element-loading',{attrs:{"active":_vm.status,"delay":0,"is-full-screen":_vm.fullPage,"color":"#4299E1","spinner":"bar-fade-scale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }